// export default Navigation;
import React, { useState, useEffect } from "react";
import pageLogo from "../../../../assets/images/png/logo.png";
import { Link, useLocation } from "react-router-dom";
import Icons from "../Icons";
import Cta from "../../ui/Cta";
import DropDown from "./DropDown";
import { chairpersondata, NAV_LINK_LIST } from "../../../../utils/defaults";
import useOutsideClickHandler from "../../../../utils/outSideClickHandler";
import MobileView from "./MobileView";

const Navigation = () => {
  const [isDropOpen, setIsDropOpen] = useState(false);
  const [isSecondDropOpen, setIsSecondDropOpen] = useState(false); // 👈 new dropdown state
  const [isNavVisible, setIsNavVisible] = useState(false);
  const pageLocation = useLocation();
  const dropRef = useOutsideClickHandler(() => setIsDropOpen(false));
  const secondDropRef = useOutsideClickHandler(() =>
    setIsSecondDropOpen(false)
  ); // 👈 new dropdown ref
  const navRef = useOutsideClickHandler(() => setIsNavVisible(false));
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const key = queryParams.get("detail");
  const schemaKey = queryParams.get("schema");

  useEffect(() => {
    if (isNavVisible) {
      document.documentElement.classList.add("overflow-clip");
    } else {
      document.documentElement.classList.remove("overflow-clip");
    }
  }, [isNavVisible]);

  const commonLinksClass =
    "font-medium !leading-100  2xl:text-base hover:text-custom-black";
  useEffect(() => {
    if (isDropOpen) {
      setIsDropOpen(false);
    }
  }, [isSecondDropOpen]);
  useEffect(() => {
    if (isSecondDropOpen) {
      setIsDropOpen(false);
    }
  }, [isDropOpen]);
  return (
    <nav className="!bg-custom-white-v3">
      <div className="container xl:max-w-[1320px] py-2 sm:py-3.5 flex justify-between items-center">
        <Link to="/">
          <img src={pageLogo} alt="logo" className="w-24 md:w-32 " />
        </Link>
        <div className="hidden xl:flex items-center gap-x-4">
          {NAV_LINK_LIST.map((obj, index) => {
            const active =
              pageLocation.pathname === obj.url ||
              pageLocation.pathname === obj.lsUrl ||
              schemaKey === obj.title.toLowerCase();

            return (
              <div key={index}>
                {index === 1 ? (
                  <div ref={secondDropRef} className="relative">
                    <button
                      onMouseOver={() => setIsSecondDropOpen(true)}
                      className={`${commonLinksClass} flex items-center gap-x-0.5 group text-custom-gray-v2`}
                      title="open resources dropdown"
                    >
                      Chairperson
                      <Icons
                        className={`${isSecondDropOpen ? "" : "rotate-180"}`}
                        pathClass="group-hover:fill-custom-black"
                        icon="arrow-up"
                      />
                    </button>
                    <div
                      className={`overflow-clip transition-all ease-linear duration-100 ${
                        isSecondDropOpen
                          ? "max-h-[170px] opacity-100"
                          : "opacity-0 max-h-10 pointer-events-none"
                      }`}
                    >
                      <DropDown
                        keyItem="resources"
                        onClick={() => setIsSecondDropOpen(false)}
                        list={chairpersondata}
                      />
                    </div>
                  </div>
                ) : index === 2 ? (
                  <div ref={dropRef} className="relative">
                    <Link
                      to={obj.lsUrl}
                      onMouseOver={() => setIsDropOpen(true)}
                      title="open dropdown"
                      className={`${commonLinksClass} flex items-center gap-x-0.5 group ${
                        active ? "text-custom-black" : "text-custom-gray-v2"
                      }`}
                    >
                      {obj.title}
                      <Icons
                        className={`${isDropOpen ? "" : "rotate-180"}`}
                        pathClass="group-hover:fill-custom-black"
                        icon="arrow-up"
                      />
                    </Link>
                    <div
                      className={`overflow-clip transition-all ease-linear duration-100 ${
                        isDropOpen
                          ? "max-h-[170px] opacity-100"
                          : "opacity-0 max-h-10 pointer-events-none"
                      }`}
                    >
                      <DropDown
                        keyItem={key}
                        onClick={() => setIsDropOpen(false)}
                        list={obj.list}
                      />
                    </div>
                  </div>
                ) : (
                  <Link
                    to={obj.url}
                    className={`${commonLinksClass} ${
                      active ? "text-custom-black" : "text-custom-gray-v2"
                    }`}
                  >
                    {obj.title}
                  </Link>
                )}
              </div>
            );
          })}

          {/* ✅ New Dropdown: Resources */}
        </div>

        <div className="flex items-center gap-x-7">
          <Cta href="/contact-us" className="max-sm:hidden">
            Get A Quote
          </Cta>
          <div ref={navRef}>
            <button
              onClick={() => setIsNavVisible(!isNavVisible)}
              title="open nav"
              className="relative xl:hidden"
            >
              <Icons
                icon="drop-open"
                className={` max-sm:size-8 ${
                  isNavVisible ? "rotate-45 opacity-0" : "opacity-100"
                }`}
              />
              <Icons
                className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10 sm:scale-150 ${
                  isNavVisible ? "rotate-0 opacity-100" : "-rotate-45 opacity-0"
                }`}
                icon="drop-close"
              />
            </button>
            <MobileView
              onclick={() => setIsNavVisible(false)}
              nav={isNavVisible}
            />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
